import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Breadcrumb from '../components/Breadcrumb';
import Footer from '../components/Footer';
import PWDModal from '../components/Modal';

const Statement = ({ topics, texts }) => {
  const [topic, setTopic] = useState(null);
  const [statement, setStatement] = useState(null);
  const [selectedOption, setSelectedOption] = useState();

  const { topicId, statementId } = useParams();

  useEffect(() => {
    // Set topic
    const topic = topics.find(topic => topic.ID === Number(topicId));
    setTopic(topic);

    // Find the currently requested statement
    const thisStatement = topic?.statements.find(s => s.ID === Number(statementId));
    setStatement(thisStatement);
    window.scrollTo(0, 0);

    // Load the possibly saved answer from localStorage
    const savedAnswer = localStorage.getItem(`statement_${topicId}_${statementId}`);
    if (savedAnswer !== null) {
      setSelectedOption(savedAnswer);
    } else {
      setSelectedOption(null);
    }
  }, [topicId, statementId, topics]);

  // Selection: save to localStorage
  const handleSelection = (optionValue) => {
    localStorage.setItem(`statement_${topicId}_${statementId}`, optionValue);
    setSelectedOption(optionValue);
  };

  // Helper: check whether a certain statement is answered
  const isStatementAnswered = (statementId) => {
    const key = `statement_${topicId}_${statementId}`;
    const answer = localStorage.getItem(key);
    return answer === "1" || answer === "0";
  };



  // Get the next statement's ID
  const nextStatementId = () => {
    const currentIndex = topic?.statements.findIndex(s => s.ID === Number(statementId));
    if (currentIndex >= 0 && currentIndex < topic?.statements.length - 1) {
      return topic.statements[currentIndex + 1].ID;
    }
    return null;
  };

  if (statement) {
    return (
      <>
        <Breadcrumb topics={topics} texts={texts} />

        <div className={`eaut-main-content statement ${topic.theme_color}`}>
          <h1>{topic.title}</h1>

          {/* 1. Move between sibling statements */}
          <h2 className="nav-title">{texts.statement_title}</h2>
          <ul className="nav">
            {topic?.statements.map((statement) => (
              <li className={`${statement.ID === Number(statementId) ? "current" : false} ${isStatementAnswered(statement.ID) ? "answered" : false}`} key={statement.ID}>
                <Link to={`/statement/${topicId}/${statement.ID}`}>{statement.ID}<span className="screen-reader-text">{statement.text}</span></Link>
              </li>
            ))}
          </ul>

          {/* 2. Display statement */}
          <h2 className="title-statement">"{statement.text}"</h2>

          {/* 3. Choices and "yes text" and/or "yes video" */}
          <>
            <div className={selectedOption === "1" ? 'yes-container selected' : 'yes-container'}>
              <label>
                <input
                  type="radio"
                  name="option"
                  value="1" // 1 for "Yes"
                  checked={selectedOption === "1"}
                  onChange={() => handleSelection("1")}
                  className="screen-reader-text"
                />
                <span className="name">{texts.statement_yes_text}</span>
              </label>

              {selectedOption === "1" && statement.yes_text && parse(statement.yes_text)}

              {selectedOption === "1" && statement.yes_embed && (
                <PWDModal modal_content={statement.yes_embed} texts={texts} close_button_text={texts.statement_close_text} white_bg={false} />
              )}
            </div>

            <label className="no">
              <input
                type="radio"
                name="option"
                value="0" // 0 for "No"
                checked={selectedOption === "0"}
                onChange={() => handleSelection("0")}
                className="screen-reader-text"
              />
              <span className="name">{texts.statement_no_text}</span>
            </label>
          </>

          {/* 4. Link to next statement or Summary if this is the last statement of a topic */}
          {selectedOption && (
            nextStatementId() !== null ? (
              <Link className="next-statement" to={`/statement/${topicId}/${nextStatementId()}`}>{texts.statement_next_text}</Link>
            ) : (
              <Link className="to-results" to={`/summary/${topicId}`}>{texts.statement_to_results_text}</Link>
            )
          )}

          <Link className="back-to-topics" to="/topics">{texts.general_choose_other_topic_text}</Link>
        </div>

        <Footer texts={texts} />
      </>
    );
  }
};

export default Statement;
